import {Params} from "@angular/router";
import {isValid, parseISO} from "date-fns";

export function getAndValidateSelectedDateQueryParam(paramsSnapshot: Params): Date | undefined {
  const regex = /^\d{4}-\d{2}-\d{2}T\d{1,2}:\d{1,2}:\d{1,2}[+-]\d{2}:\d{2}$/g;
  if(
    paramsSnapshot &&
    paramsSnapshot['date'] &&
    regex.test(paramsSnapshot['date']) &&
    isValid( new Date(paramsSnapshot['date']) )
  ) {

    return parseISO(paramsSnapshot['date']);
  }
  return undefined;
}
